import $ from 'jquery';
import LP from '../0-lp';


LP.dlgResultView = {

    storedTabText: '',

    prepare: function (selector, params) {
        $(selector).click(function () {
            if (!$(this).is('[disabled]')) {
                LP.Dialog.open($.extend(params, {
                    name: 'resultview',
                    ajax: $(this).attr('url'),
                    request: $(this).attr('url_params'),
                    title: this.title,
                    width: 720,
                    height: 690,
                    onLoad: LP.dlgResultView.onLoad,
                    beforeSubmit: LP.dlgResultView.beforeSubmit,
                    onClose: LP.dlgResultView.onClose,
                    dialogClass: 'lp-tabs-horizontal'
                }));
            }
            return false;
        });
    },

    onLoad: function () {
        LP.Dialog.initTabs({
            name: '#resultViewDialogTabs',
            onTabLoaded: LP.dlgResultView.onTabLoaded,
            beforeTabChanged: LP.dlgResultView.beforeTabChanged,
            afterTabChanged: LP.dlgResultView.afterTabChanged,
            cache: true,
            loaderType: 'rotate-snake',
            loadedType: 'arrow'
        });

        //LP.dlgResultView.onChartTabLoaded();
        LP.dlgResultView.onFilterTabLoaded();
        LP.dlgResultView.onVisibilityTabLoaded();
        LP.dlgResultView.onCommentsTabLoaded();
    },

    onClose: function () {
        var itemId = $('#dlgResultViewId').val();
        window.Browser.send('backend/closeEditDialog/', 'itemId=' + itemId);
        return false;
    },

    onTabLoaded: function (ui, tabname) {
        // nötig, da beim Aufruf dieser Funktion beim Sprachwechsel beide parameter leer sind
        tabname = LP.Dialog.getTabName();
        if (tabname == 'chart') {
            LP.dlgResultView.onChartTabLoaded();
        }
        /*if (tabname=='filter')	  LP.dlgResultView.onFilterTabLoaded();
         if (tabname=='visibility')	  LP.dlgResultView.onVisibilityTabLoaded(); */
    },

    onChartTabLoaded: function () {

        LP.pollResultsCharts.initChart('#question-chart-form');
    },

    onFilterTabLoaded: function () {
        LP.filters.init({root: '#fs-resultview-filter'});
    },

    onVisibilityTabLoaded: function () {
        LP.filters.init({root: '#fs-resultview-visibility'});
    },

    onCommentsTabLoaded: function () {
        LP.commentsDlg.initButtons();
    },

    beforeTabChanged: function (ui, refresh) {
        LP.Dialog.hideErrors();

        var tabname = LP.Dialog.getTabName();
        if (tabname == 'visibility') {
            LP.filters.removeEmptyTerms($('#fs-resultview-visibility'));
        }
        if (tabname == 'filter') {
            LP.filters.removeEmptyTerms($('#fs-resultview-filter'));
        }

        var tabResult;
        if (tabname == 'comments') {
            tabResult = LP.commentsDlg.askDiscard();
        } else {
            tabResult = LP.dlgResultView.saveTab(refresh);
        }

        return tabResult;
    },

    afterTabChanged: function () {
        return true;
    },

    saveTab: function (refresh) {
        var tabResult = false;
        var tabName = LP.Dialog.getTabName();

        var url = 'backend/saveResultViewTab/';
        var params = $('#resultViewForm').serialize();

        if (refresh) {
            params += '&refresh=1';
        }
        if (tabName == 'chart') {
            params += LP.pollResultsCharts.getChartParams('resultview');
        }

        window.Browser.send(
            url, params,
            function (json) {
                LP.Dialog.showError(json, $('.tabError', LP.Dialog.getInstance(), false));
                tabResult = true;
            },
            function (json) {
                LP.Dialog.showError(json, $('.tabError', LP.Dialog.getInstance(), false));
                tabResult = false;
            },
            false // send syncron!
        );

        return tabResult;
    },

    onChangeLanguage: function (lang) {
        LP.dlgResultView.storeEditorText();	 // store current text in the editor with old language
        LP.dlgResultView.setEditorText(lang); // set current text in the editor with new language

        LP.refreshPage();

        $('#dialog_language').val(lang);	// set new editing language

        return false; // do not apply and reload dialog
    },

    beforeSubmit: function () {
        LP.Dialog.hideErrors();
        var result = LP.dlgResultView.saveTab(false);
        return result;
    }
};

LP.dlgResultTabVisible = {
    dispatching: false,

    prepare: function (selector, params) {
        $(selector).click(function () {
            if (!$(this).is('[disabled]')) {
                LP.Dialog.open($.extend(params, {
                    name: 'resultviewVisible',
                    ajax: $(this).attr('url'),
                    request: $(this).attr('url_params'),
                    title: this.title,
                    width: 750,
                    height: 500,
                    onLoad: LP.dlgResultTabVisible.onLoad,
                    beforeSubmit: LP.dlgResultTabVisible.beforeSubmit,
                    onClose: LP.dlgResultTabVisible.onClose
                }));
            }
            return false;
        });
    },

    onLoad: function () {
        LP.filters.init({root: '#fs-resultview-visibility'});
    },

    onClose: function () {
        var itemId = $('#dlgResultViewId').val();
        window.Browser.send('backend/closeEditDialog/', 'itemId=' + itemId);
        return false;
    },

    beforeSubmit: function () {
        LP.filters.removeEmptyTerms($('#fs-resultview-visibility'));

        LP.Dialog.hideErrors();
        var result = LP.dlgResultTabVisible.onSave(false);

        return result;
    },

    onSave: function (refresh) {
        var tabResult = false;
        var url = 'backend/saveResultViewTab/';
        var params = $('#resultViewForm').serialize();

        if (refresh) {
            url = url + '&refresh=1';
        }

        window.Browser.send(
            url,
            params,
            function (json) {
                LP.Dialog.showError(json, $('.tabError', LP.Dialog.getInstance(), false));
                tabResult = true;
            },
            function (json) {
                LP.Dialog.showError(json, $('.tabError', LP.Dialog.getInstance(), false));
                tabResult = false;
            },
            false // send syncron!
        );

        return tabResult;
    }
};